import { createSelector } from 'reselect';

export const selectExampleGallery = (state) => state.ExampleGallery;
export const selectIsOpen = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.isOpen,
);
export const selectExampleGroupName = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.exampleGroupName,
);
export const selectExampleName = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.exampleName,
);
export const selectDossierUrl = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.dossierUrl,
);
export const selectExampleId = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.exampleId,
);
export const selectExampleDesc = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.exampleDesc,
);
export const selectImage = createSelector(
  selectExampleGallery,
  (ExampleGallery) => ExampleGallery.image,
);
